<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <span class="text-h5">{{ isNewRecord ? '新增客戶' : '編輯客戶' }}</span>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4" style="max-height: 70vh">
        <CustomerDetailsForm
          v-if="dialog"
          ref="form"
          :key="id"
          :id="id"
          @saved="handleSaved"
          @cancel="close"
          @deleted="handleDeleted"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomerDetailsForm from './CustomerDetailsForm';

export default {
  name: 'CustomerDetailsDialog',
  components: {
    CustomerDetailsForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'new',
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isNewRecord() {
      return !this.id || this.id === 'new';
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    handleSaved() {
      this.$emit('saved');
      this.close();
    },
    handleDeleted() {
      this.$emit('deleted');
      this.close();
    },
  },
};
</script>
